<script lang="ts">
	import { tenants } from "@core/config/tenants.js";
	import { Locale } from "@core/schema/Locale.js";
	import { localAliasNameMap } from "@core/schema/names/localAliasNameMap.js";
	import { localeNameMap } from "@core/schema/names/localeNameMap.js";
	import { getHomepagePath } from "@core/schema/paths/getHomepagePath.js";
	import { getGlobalTemplateProps } from "../../contexts/getGlobalTemplateProps.js";

	const { tenant, pagePath } = getGlobalTemplateProps();
</script>

<div class="hidden sm:flex full-width font-medium">
	{#each Object.values(Locale) as targetLocale, index (targetLocale)}
		{#if index !== 0}
			<span class="text-white/80" aria-hidden="true">|</span>
		{/if}
		{#if targetLocale === tenant.locale}
			<span title={localeNameMap[targetLocale][tenant.locale]} class=" cursor-pointer px-2">
				{localAliasNameMap[targetLocale]}
			</span>
		{:else}
			<a
				href={pagePath[targetLocale] ?? getHomepagePath(tenants[targetLocale])}
				title={localeNameMap[tenant.locale][targetLocale]}
				class="font-medium text-white/80 hover:text-white transition-colors px-2"
			>
				{localAliasNameMap[targetLocale]}
			</a>
		{/if}
	{/each}
</div>
